import { Button, Flex } from 'antd';

/**
 * Footer bar for filter panels: Reset and Apply buttons.
 *
 * Fully controlled — receives state and callbacks.
 * Knows nothing about state management, panels, or data sources.
 *
 * `canApply` is for panels that can hold a *dirty but unusable* draft: Apply
 * must be blocked, Reset must not be, or the user is stranded. Defaults to
 * `isDirty`, so panels with nothing to validate behave as before.
 *
 * @param {{ isDirty: boolean, isSaving: boolean, canApply?: boolean,
 *   onReset: () => void, onApply: () => void }} props
 */
const FilterActions = ({ isDirty, isSaving, canApply = isDirty, onReset, onApply }) => {
	return (
		<Flex
			gap={12}
			style={{
				padding: '12px 16px',
				borderTop: '1px solid var(--ant-color-border)',
				width: '100%',
			}}>
			<Button onClick={onReset} disabled={isSaving || !isDirty} style={{ flex: 1 }}>
				Reset
			</Button>
			<Button
				type="primary"
				onClick={onApply}
				disabled={isSaving || !canApply}
				loading={isSaving}
				style={{ flex: 1 }}>
				Apply
			</Button>
		</Flex>
	);
};

export default FilterActions;
